import React from 'react';
import { Carousel } from 'react-bootstrap';
import './PosterSlider.css';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import config from './../../config.json';


const PosterSlider = ({ posters }) => {

    const readyPosters = [];
    posters.forEach(element => {
        if (window.innerWidth >= 576 && element.image1) {
            readyPosters.push({
                _id: element._id,
                image1: element.image1,
                image2: element.image2 || element.image1
            });
        }
        else if (window.innerWidth < 576 && element.image2) {
            readyPosters.push({
                _id: element._id,
                image1: element.image1 || element.image2,
                image2: element.image2
            })

        }
    });
    readyPosters.sort((a, b) => (a.priority > b.priority) ? 1 : ((b.priority > a.priority) ? -1 : 0))

    return (
        <div className='poster-slider-layer rtl'>
            <Carousel dir='rtl'>
                {
                    readyPosters.map(poster =>
                        <Carousel.Item key={poster._id}>
                            <LazyLoadImage
                                width={'100%'}
                                height={window.innerWidth < 576 ? '250' : '400'}
                                src={`${config.api_address}/upload/${window.innerWidth >= 576 ? poster.image1 : poster.image2}`}
                                style={{ height: window.innerWidth < 576 ? '250' : '400', objectFit: 'cover', width: '100%' }}
                                effect="blur"
                            />
                        </Carousel.Item>
                    )
                }
            </Carousel>
        </div>
    );
}

export default PosterSlider;